export const USABLE_VIALS = 'usableVials';
export const UNUSABLE_VIALS = 'unusableVials';
export const EARMARKED = 'earmarked';
export const FORM_A = 'forma';
export const DESTRUCTION = 'destruction';
export const INCIDENT = 'incident';
// Earmark movement types
export const CREATED = 'created';
export const USED = 'used';
export const RETURNED = 'returned';
// Form A status
export const TEMPORARY = 'temporary';
export const RECEIVED = 'received';

// Form A edit access (backend-driven enum on OutgoingStockMovementSerializer.edit_access)
export const EDIT_ACCESS_NONE = 'none';
export const EDIT_ACCESS_COMPLETION_ONLY = 'completion_only';
export const EDIT_ACCESS_FULL = 'full';
// campaign category for on_hold/is_test
export const REGULAR = 'REGULAR';
export const TEST_CAMPAIGN = 'TEST_CAMPAIGN';
export const CAMPAIGN_ON_HOLD = 'CAMPAIGN_ON_HOLD';
export const ALL_ROUNDS_ON_HOLD = 'ALL_ROUNDS_ON_HOLD';
export const ROUND_ON_HOLD = 'ROUND_ON_HOLD';
